import { useFetcher, useLoaderData, useLocation } from '@remix-run/react'
import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body'
import PlentyHeading from '#app/components/typography/plenty-heading'
import { Icon } from '#app/components/ui/icon'
import { TOTAL_ITEMS_PER_PAGE } from '#app/constants/clerk-api'
import useAmplitudeContext from '#app/hooks/use-amplitude-context'
import useUserPreferences from '#app/hooks/use-user-preferences'
import { type loader } from '#app/routes/_public+/products+/$slug'

const MoreProducts = () => {
	const location = useLocation()
	let { t } = useTranslation('product_list_page')
	const { trackAmplitudeEvent } = useAmplitudeContext()
	const removeSelectedStoreFetcher = useFetcher()
	const data = useLoaderData<typeof loader>()
	const { categoriesData, totalCountAllStores, totalCount, page } = data
	const pathParts = location.pathname.split('/')
	const categoryKey = pathParts[2] || ''
	const productsPerPage = TOTAL_ITEMS_PER_PAGE
	const userPreferences = useUserPreferences()
	if (
		!userPreferences?.selectedStores ||
		userPreferences?.selectedStores.length === 0
	)
		return null

	const removeSelectedStore = () => {
		trackAmplitudeEvent('store selector more products clicked')
		removeSelectedStoreFetcher.submit(null, {
			method: 'POST',
			action: '/resources/removeSelectedStores',
		})
	}

	const currentCategory = categoriesData.result.find(
		(category: any) => category.id === categoryKey,
	)
	// Correctly calculate totalPages based on the fixed number of products per page
	const totalPages = Math.max(1, Math.ceil(data.totalCount / productsPerPage))
	if (totalCountAllStores === totalCount || totalPages !== page) return

	return (
		<div className="mt-2 flex flex-col items-center justify-center space-y-4 bg-beige-50 px-4 py-6 md:px-32">
			<PlentyBody>
				{t('store_selector_more_products_message_title', {
					category: currentCategory.name,
				})}
			</PlentyBody>
			<div
				className="flex cursor-pointer flex-row space-x-1"
				onClick={removeSelectedStore}
			>
				<PlentyHeading as="h7">
					{t('store_selector_more_products_message_heading')}
				</PlentyHeading>
				<Icon name="right-arrow" size="lg" />
			</div>
		</div>
	)
}

export default MoreProducts
